import { getButtonRole } from '../../utils';
import { Button } from 'antd';
import React from 'react';

const Index = (props: any) => {
  return <>{getButtonRole(props?.role) ? <Button {...props} /> : null}</>;
};

export default Index;
